<template>

  <div v-for="(item, index) in props.dataSource" :key="item.id" class="publisher-item"
    @click="goToPublisherDetail(item)" :style="{ cursor: props.disabled ? 'default' : 'pointer' }">
    <div class="publisher-info">
      <div class="creator-info">
        <div class="img-wrapper">
          <LogoImage :maxWidth="'95%'" :logoUrl="item?.publicImage" :brandName="item?.creatorName" :width="136"
          :height="136" :fontSize="16" />
        </div>
      
        <div class="info">

         
          <div class="info-item-middle mb-20">
            <div class="info-item">
              <div class="label">{{ st('placement.labelPublisherName') }}</div>
              <a-tooltip v-if="shouldShowTooltip(`item-${item.id}-promotion-countries`)" placement="top" overlayClassName="wide-tooltip" :overlayInnerStyle="{ maxWidth: '900px', whiteSpace: 'normal', wordBreak: 'break-word' }"
                :title="getFullText(item?.promotionCountries)">
                <div class="value product-categories-value"
                  :data-overflow-check="`item-${item.id}-promotion-countries`">
                  {{ item?.creatorName ? item?.creatorName : '--' }}
                </div>
              </a-tooltip>
              <div v-else class="value product-categories-value"
                :data-overflow-check="`item-${item.id}-promotion-countries`"
                :style="{ color: item?.promotionCountries ? '' : 'rgba(15, 6, 41, 0.3)' }">
                {{ item?.promotionCountries ? getComputedData(item?.promotionCountries) : '--' }}
              </div>
            </div>
            <div class="info-item">
              <div class="label">{{ st('placement.labelPromotionCountries') }}</div>
              <a-tooltip  overlayInnerStyle="{ width: '900px', whiteSpace: 'normal', wordBreak: 'break-word' }" v-if="shouldShowTooltip(`item-${item.id}-promotion-methods`)" placement="top" overlayClassName="wide-tooltip" 
                :title="getFullText(item?.promotionMethods)">
                <div class="value product-categories-value" :data-overflow-check="`item-${item.id}-promotion-methods`">
                  {{ item?.promotionCountries ? getComputedData(item?.promotionCountries) : '--' }}
                </div>
              </a-tooltip>
              <div v-else class="value product-categories-value"
                :data-overflow-check="`item-${item.id}-promotion-methods`"
                :style="{ color: item?.promotionCountries ? '' : 'rgba(15, 6, 41, 0.3)' }">
                {{ item?.promotionCountries ? getComputedData(item?.promotionCountries) : '--' }}
              </div>
            </div>

            <div class="info-item">
              <div class="label">Product Categories:</div>
              <a-tooltip overlayClassName="wide-tooltip"  v-if="shouldShowTooltip(`item-${item.id}-product-categories`)" placement="left"  
                :title="getFullText(item?.promotionProductCategories)">
                <div class="value product-categories-value" :data-overflow-check="`item-${item.id}-product-categories`">
                  <span :style="{ color: item?.promotionProductCategories ? '' : 'rgba(15, 6, 41, 0.3)' }">
                    {{ item?.promotionProductCategories ? getComputedData(item?.promotionProductCategories) : '--' }}
                  </span>
                </div>
              </a-tooltip>
              <div v-else class="value product-categories-value"
                :data-overflow-check="`item-${item.id}-product-categories`"
                :style="{ color: item?.promotionProductCategories ? '' : 'rgba(15, 6, 41, 0.3)' }">
                {{ item?.promotionProductCategories ? getComputedData(item?.promotionProductCategories) : '--' }}
              </div>
            </div>
          </div>


          <div class="info-item mb-20">
            <div class="label">{{ st('placement.labelBio') }}</div>
            <a-tooltip v-if="shouldShowTooltip(`item-${item.id}-bio`)" placement="top" overlayClassName="wide-tooltip" :title="item?.publicBio || '--'">
              <div class="value product-categories-value value-no-bold" :data-overflow-check="`item-${item.id}-bio`">
                <span>
                  {{ item?.publicBio ? item?.publicBio : '--' }}
                </span>
              </div>
            </a-tooltip>
            <div v-else class="value value-no-bold product-categories-value"
              :data-overflow-check="`item-${item.id}-bio`"
              :style="{ color: item?.publicBio ? '' : 'rgba(15, 6, 41, 0.3)' }">
              {{ item?.publicBio ? item?.publicBio : '--' }}
            </div>
          </div>
          
          <div class="program-status">

            <div class="label mb-4">{{ st('placement.labelLinks') }}</div>

            <!-- Amazon Associate -->
            <div class="info-item" >
              <template v-for="link in item.links" :key="link.id" v-if="item.links&&item.links.length>0">
                <div class="item" @click.stop="goToLink(link)" v-if="link.url">
                <svg-icon class="icon-app-default" name="lianjie" style="font-size: 12px;padding: 4px;"
                        v-if="link.name === 'Other' || link.name === 'Website/Blog'" />
                <svg-icon :name="link?.name?.toLowerCase()" class="icon-app" v-else/>
                <span class="item-text">{{link.name}}</span>
                <svg-icon name="jiantou-you-cu" style="color: #0f0629;"/>
              </div>
              </template>
              <template v-else>
                <div style="color:rgba(15, 6, 41, 0.3)">
                  <span >--</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script setup>
import { defineProps, computed, ref, onMounted, nextTick, watch, onUnmounted } from 'vue'
import LogoImage from '@/components/LogoImage.vue'
import debounce from 'lodash/debounce'
import SvgIcon from '~/components/SvgIcon.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()

const props = defineProps({
  dataSource: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: false
  },
  hasAvailablePrograms: {
    type: Boolean,
    default: true
  }
})
const associateProgramRef=ref(null)

// 暴露 associateProgramRef 给父组件
defineExpose({
  associateProgramRef,
  // 添加一个方法来获取所有 associateProgramRef
  getAllAssociateProgramRefs: () => {
    return document.querySelectorAll('.program-status')
  }
})
// 存储每个字段是否溢出的状态
const overflowStates = ref({})

// 检查单个元素是否溢出
const checkOverflow = (element) => {
  if (!element) return false
  // 当scrollHeight大于clientHeight时，说明内容溢出了
  return element.scrollHeight > element.clientHeight
}

// 检查所有元素的溢出状态
const checkAllOverflow = async () => {
  await nextTick()
  const newStates = {}

  // 查找所有带有data-overflow-check属性的元素
  const elements = document.querySelectorAll('[data-overflow-check]')
  elements.forEach(element => {
    const key = element.getAttribute('data-overflow-check')
    newStates[key] = checkOverflow(element)
  })

  overflowStates.value = newStates
}

// 简单的判断方法：是否应该显示tooltip
const shouldShowTooltip = (key) => {
  return overflowStates.value[key] || false
}
const goToLink = (link) => {
  if(!link.url) {
    return
  }
  window.open(link.url, '_blank')
}
// 获取完整的文本内容
const getFullText = (item) => {
  if (!item) return '--'
  if (Array.isArray(item)) {
    if (item.length > 0) {
      return item.map(i => i.name).join(', ')
    }
    return '--'
  }
  return '--'
}

// 创建防抖版本的checkAllOverflow函数
const debouncedCheckOverflow = debounce(checkAllOverflow, 200)

onMounted(() => {
  // 延迟执行，确保DOM完全渲染
  setTimeout(() => {
    checkAllOverflow()
  }, 100)

  // 监听窗口大小变化
  window.addEventListener('resize', debouncedCheckOverflow)
})

// 组件卸载时清理事件监听器
onUnmounted(() => {
  window.removeEventListener('resize', debouncedCheckOverflow)
})

// 监听数据变化
watch(() => props.dataSource, () => {
  // 防抖延迟执行
  setTimeout(() => {
    checkAllOverflow()
  }, 200)
}, { deep: true })




// 方法2：使用computed工厂函数
const getComputedData = (item) => computed(() => {

  if (Array.isArray(item)) {
    if (item.length > 0) {
      return item.map(item => item.name).join(',')
    }
    else {
      return '--'
    }
  }
  else {
    return '--'
  }
})

function goToPublisherDetail (item) {
  if (props.disabled) {
    return
  }
  const data = {
    id: item.id,
    creatorName: item.creatorName,
    publicImage: item.publicImage,
    promotionCountries: item.promotionCountries,
    promotionMethods: item.promotionMethods,
    promotionProductCategories: item.promotionProductCategories,
    publicBio: item.publicBio,
    associateBrandCount: item.associateBrandCount,
    associateEnabled: item.associateEnabled,
    links: item.links
  }
  sessionStorage.setItem('publisherDetail', JSON.stringify(data))
  window.open(`/seller/publishers/${item.id}`, '_blank')
}
</script>
<style>

.wide-tooltip .ant-tooltip-inner {
  margin-left: -80px;
  min-width: 400px !important; 
  white-space: normal !important;
  word-break: break-word !important;
}
</style>
<style scoped lang="less">
// .publisher-table removed: empty ruleset

.associate-tooltip {
  margin-bottom: 2px !important;
  transform: translateY(13px) !important;
}

.publisher-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.publisher-item {
  
  gap: 20px;
  flex: 1 0 0;
 
  background: #FFF;
 
}

.publisher-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
}

.creator-info {
  display: flex;
  gap: 16px;
  height: 100%;
  .img-wrapper{
    width: 136px;
    height: 136px;
    border-radius: 8px;
    overflow: hidden;
    background-color: var(--bg-gray-2);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--bg-gray-2);
  }
  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .info-item-middle {
    display: flex;
    gap: 16px;
    justify-content: space-between;
    align-items: stretch;

    .info-item {
      flex: 1;
    }

  }

  .creator-name {
    font-size: 18px;
    font-weight: 600;
    color: var(--text-color);
  }
}

.program-status {
  .info-item {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  // .item:not(:first-child):not(:last-child) {
  //   margin: 0 5px;
  // }
  .icon-app{
    font-size: 20px;
      border-radius: 4px;
      overflow: hidden;
      background-color: var(--bg-gray-5);
  }
  .icon-app-default {
      font-size: 16px;
      padding: 2px;
      border-radius: 4px;
      overflow: hidden;
      background-color: var(--bg-gray-5);
      color: var(--dark-4);
    }
  .item {
    display: flex;
    padding: 3px 4px;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #F1F0F5;

    .icon {
      width: 20px !important;
      height: 20px !important;
    }

    .item-text {
      color: #0f0629;
      font-family: "Sora";
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.3px;
      opacity: 0.7;
    }
  }
}

.label {
  color: #0f0629;
  opacity: 0.5;
  font-family: "Sora";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.value {
  color: #0f0629;
  font-family: "Sora";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.4px;
  word-break: break-word;
}

.value-no-bold {
  font-weight: normal !important;
}

.name {
  color: #0f0629;
  font-family: "Sora";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.4px;

}

.mb-20 {
  margin-bottom: 20px;
}

.mb-4 {
  margin-bottom: 2px;
}

.product-categories-value {
  display: -webkit-box;
  line-clamp: 3; // standard property for compatibility
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}

.status-tag {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;

  &.available {
    background-color: var(--success-color-bg);
    color: var(--success-color);
  }

  &.unavailable {
    background-color: var(--error-color-bg);
    color: var(--error-color);
  }
}









// @media screen and (max-width: 768px) {
//   .publisher-grid {
//     grid-template-columns: 1fr;
//   }

//   .creator-info {
//     .info {
//       grid-template-columns: 1fr;
//     }
//   }
// }</style>